"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentBreakdownPlanType = void 0;
var PaymentBreakdownPlanType;
(function (PaymentBreakdownPlanType) {
    PaymentBreakdownPlanType["revolving"] = "revolving";
    PaymentBreakdownPlanType["fixedFinanceCharge"] = "fixedFinanceCharge";
    PaymentBreakdownPlanType["simpleInterest"] = "simpleInterest";
    PaymentBreakdownPlanType["recordingCharge"] = "recordingCharge";
    PaymentBreakdownPlanType["signingCharge"] = "signingCharge";
})(PaymentBreakdownPlanType || (exports.PaymentBreakdownPlanType = PaymentBreakdownPlanType = {}));
